<template>
  <div id="app">
    <div class="header">
      <div class="toprow">
        <div class="logo"></div>
      </div>
      <div class="menu">
        <router-link :to="{name: item.name}" tag="a" v-for="(item,index) in menu" :key="index">{{item.txt}}</router-link>
      </div>
    </div>
    <router-view />
    <div class="footer">Copyright© 2020 北京运多多网络科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备15048003号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      menu:[
        {
          name: 'home',
          txt: '首页'
        },
        {
          name: 'consultation',
          txt: '付费资讯'
        },
//        {
//          name: 'aboutme',
//          txt: '关于我们'
//        },
//        {
//          name: 'contactus',
//          txt: '联系我们'
//        },
      ],
      num:0
    }
  },
  mothods:{

  },
  mounted: function () {
  }
}
</script>

<style>
  html,body{height:100%}
  body {background: #f3f3f3}
  .header {height: 80px; border-bottom: 1px solid #FF5555; background: #fff; padding: 0 20px}
  .header .logo {float: left; width: 40px; height: 40px; margin-top: 20px; background:url("img/logoicowhite.png") center no-repeat #ff5555; background-size: 60%; border-radius: 50%;}
  .header .menu {float: right; line-height: 50px; margin-top: 30px}
  .header .menu a {float: left; width: 180px; text-align: center; line-height: 50px; background: #fff; color: #FF5555; font-size: 14px}
  .header .menu .router-link-exact-active {background: #ff5555; color: #fff}
  .footer {height: 40px; margin-top: 50px; background: #000; color: #fff; font-size: 12px; line-height: 40px; text-align: center}
</style>



// WEBPACK FOOTER //
// src/App.vue